import(/* webpackMode: "eager" */ "/src/apps/creator-ui/app/error.tsx");
